import {SportsTeamListBlock} from "@/lib/interfaces/blocks";
import BulbIcon from "@/components/icons/BulbIcon";
import BettingGuidesIcon from "@/components/icons/BettingGuidesIcon";
import CasinoChipIcon from "@/components/icons/CasinoChipIcon";
import OfferIcon from "@/components/icons/OfferIcon";
import PlayingCardsIcon from "@/components/icons/PlayingCardsIcon";
import PromoCodeIcon from "@/components/icons/PromoCodeIcon";
import SectionTitle from "@/components/SectionTitle";
import SectionContent from "@/components/SectionContent";
import {Fragment, useEffect, useState} from "react";
import {Team} from "@/lib/interfaces/events";
import {getTeams} from "@/lib/teams";
import {PaginatorMeta} from "@/lib/interfaces/paginator";
import Paginator from "@/components/Paginator";
import Image from "next/image";
import '@/styles/teams.scss';
import SoccerIcon from "@/components/icons/SoccerIcon";
import Link from "next/link";

type SportsTeamListType = {
    block: SportsTeamListBlock
}

const SportTeam = ({team}: {team: Team}) => {
    const image = team.media.filter(image => {
        return image.role === 'logo';
    });
    return (
        <Link href={`/teams/${team.sport?.slug ?? 'football'}/${team.slug}`} className={`teams-list__team`}>
            <div className={`team-logo`}>
                {image.length > 0 ? (
                    <Image src={image[0].original_webp} alt={`Image for ${team.name}`} width={48} height={48} />
                ) : (
                    <SoccerIcon/>
                )}
            </div>
            <div className={`team-name`}>
                {team.name}
            </div>
        </Link>
    );
}

export default function SportsTeamList({block}: SportsTeamListType) {
    const [loading, setLoading] = useState(true);
    const [teams, setTeams] = useState<Team[]>([]);
    const [meta, setMeta] = useState<PaginatorMeta|null>(null);
    const [page, setPage] = useState(1);
    useEffect(() => {
        getTeams(
            block.content.browsers.sport.length ? block.content.browsers.sport[0] : null,
            page
        ).then((res) => {
            setMeta(res.meta);
            setTeams(res.data);
            setLoading(false);
        })
    }, [page, block.content.browsers.sport]);
    const shouldShowTitle =
        block.position !== 1 || !/\b\w+\s+(vs|VS)\s+\w+\b/i.test(block.content.title ?? '');

    let iconComponent;

    switch (block.content.icon) {
        case 'bulb':
            iconComponent = <BulbIcon />;
            break;
        case 'betting_guides':
            iconComponent = <BettingGuidesIcon />;
            break;
        case 'casino_chip':
            iconComponent = <CasinoChipIcon />;
            break;
        case 'offer':
            iconComponent = <OfferIcon />;
            break;
        case 'playing_cards':
            iconComponent = <PlayingCardsIcon />;
            break;
        case 'promo_code':
            iconComponent = <PromoCodeIcon />;
            break;
        default:
            iconComponent = null;
            break;
    }

    const handlePageChange = (event: any) => {
        setLoading(true);
        setPage(event.selected + 1);
    }

    return (
        <section className="eo-section">
            {shouldShowTitle && block.content.title && block.content.title.length > 0 && (
                <SectionTitle title={block.content.title}>
                    <div className="icon m-icon">
                        {iconComponent}
                    </div>
                </SectionTitle>
            )}
            <SectionContent>
                {loading ? (
                    <div className="eo-spinner-box">
                        <span className="eo-spinner"></span>
                    </div>
                ) : (
                    <div className={`teams-list`}>
                        {teams.map(team => (
                            <SportTeam key={team.id} team={team} />
                        ))}
                    </div>
                )}
                {meta &&
                    <Paginator paginator={meta} onPageChange={handlePageChange} />
                }
            </SectionContent>
        </section>
    );
}